/**
 * @typedef {Object} StatusCodes - The status codes that can be used in the Result class.
 *  These codes are used to indicate the status of the result and are the same as the commonly known HTTP status codes.
 */
type StatusCodes = {
    [key in 200 | 201 | 400 | 401 | 403 | 404 | 409 | 418 | 422 | 500]: number;
};

/**
 * @class Result
 * Result class to return a result from a function. This class is used to make the communication between the client and server uniform.
 */
export class Result {
    /**
     * @param {keyof StatusCodes} status - The status code of the result.
     * @param {string} message - The message describing the result.
     * @param {object|null} object - The object returned as a result, or null if there is none.
     */
    constructor(
        public status: keyof StatusCodes,
        public message: string,
        public object: any = null
    ) {}
}
